import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

import DraftTextEditorWrapper from './components/DraftTextEditorWrapper';
import LockControl from './components/LockControl';
import EditViewSectionContainer from './EditViewSectionContainer';
import { getEditFormNodeId, getEditFormNode, getNodeLockingAllowed } from '../../selectors';
import { updateFormNodeValue as updateFormNodeValueActionCreator } from '../../actions/nodeActions';

const TEXT_ELEMENT_EDIT_LABEL = 'Text Element';
const INPUT_PLACEHOLDER = 'This will appear on your form.';

/**
 * Component for main guest information fields like first name, last name and email.
 */
const EditContentNode = ({ description, formNodeId, updateFormNodeValue, nodeLockingAllowed }) => (
    <EditViewSectionContainer>
        <SuiContainer variation="flex-group">
            <DraftTextEditorWrapper
                fullWidth
                label={TEXT_ELEMENT_EDIT_LABEL}
                value={description}
                placeholder={INPUT_PLACEHOLDER}
                onChangeLabel={(e, label, labelMarkup) => updateFormNodeValue(formNodeId, 'description', labelMarkup)}
            />
        </SuiContainer>
        {nodeLockingAllowed && (
            <SuiContainer variation="flex-group">
                <LockControl formNodeId={formNodeId} />
            </SuiContainer>
        )}
    </EditViewSectionContainer>
);

EditContentNode.propTypes = {
    updateFormNodeValue: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    formNodeId: PropTypes.string.isRequired,
    nodeLockingAllowed: PropTypes.bool.isRequired,
};

EditContentNode.defaultProps = {};

const mapStateToProps = (state) => {
    const node = getEditFormNode(state);
    const formNodeId = getEditFormNodeId(state);
    const nodeLockingAllowed = getNodeLockingAllowed(state);

    return {
        description: node ? node.description : undefined,
        formNodeId,
        nodeLockingAllowed,
    };
};

const mapDispatchToProps = {
    updateFormNodeValue: updateFormNodeValueActionCreator,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditContentNode);
